<template>
  <div class="room-setting-table">
    <table class="table">
      <!-- NOTE: Table Header -->
      <thead>
        <tr>
          <th scope="col">
            {{ $t("SmartScheduling.Room.Table.Number") }}
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort"
              :class="{
                'table-sort-up': sortObj.nameJa === 'asc',
                'table-sort-down': sortObj.nameJa === 'desc'
              }"
              @click="changeSortType('nameJa')"
            >
              {{ $t("SmartScheduling.Room.Data.NameJP") }}
            </button>
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort"
              :class="{
                'table-sort-up': sortObj.nameEn === 'asc',
                'table-sort-down': sortObj.nameEn === 'desc'
              }"
              @click="changeSortType('nameEn')"
            >
              {{ $t("SmartScheduling.Room.Data.NameEN") }}
            </button>
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort"
              :class="{
                'table-sort-up': sortObj.capacity === 'asc',
                'table-sort-down': sortObj.capacity === 'desc'
              }"
              @click="changeSortType('capacity')"
            >
              {{ $t("SmartScheduling.Room.Data.Capacity") }}
            </button>
          </th>
          <th scope="col">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort"
              :class="{
                'table-sort-up': sortObj.location === 'asc',
                'table-sort-down': sortObj.location === 'desc'
              }"
              @click="changeSortType('location')"
            >
              {{ $t("SmartScheduling.Room.Data.Location") }}
            </button>
          </th>
          <th scope="col">
            {{ $t("SmartScheduling.Room.Table.EditHeader") }}
          </th>
        </tr>
      </thead>

      <!-- NOTE: Table Body -->
      <tbody>
        <tr
          v-for="item in filterdItem"
          :key="item.key"
        >
          <td>{{ item.index + 1 }}</td>
          <td>{{ item.nameJa }}</td>
          <td>{{ item.nameEn }}</td>
          <td>{{ item.capacity }}</td>
          <td>{{ item.location }}</td>
          <td>
            <button
              type="button"
              class="btn btn-borderless-primary"
              @click="openModal(item.index)"
            >
              <i
                class="fa fa-pencil"
                aria-hidden="true"
              />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="table-empty"
      v-if="!filterdItem.length"
    >
      <div class="table-empty-label">
        {{ $t("General.NoData") }}
      </div>
    </div>
    <nav
      class="pagination"
      v-else
    >
      <p>
        {{ `${pagenationCount.start} - ${pagenationCount.end} of ${pagenationCount.all}` }}
      </p>
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.start <= 1}"
          @click="subPagenationIndex"
        >
          <i class="fas fa-chevron-left" />
        </button>
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.end >= pagenationCount.all}"
          @click="addPagenationIndex"
        >
          <i class="fas fa-chevron-right" />
        </button>
      </div>
    </nav>
    <!-- NOTE: Edit Modal -->
    <VModal :is-open.sync="isOpen">
      <template #title>
        {{ $t("SmartScheduling.Room.EditTitle") }}
      </template>
      <template #body>
        <div class="form-group">
          <label for="email">{{ $t("SmartScheduling.Room.Data.Email") }}</label>
          <input
            type="email"
            id="email"
            v-model="editData[editIndex].email"
            class="form-control"
          >
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="jaName">{{ $t("SmartScheduling.Room.Data.NameJP") }}</label>
            <input
              type="text"
              id="jaName"
              v-model="editData[editIndex].nameJa"
              class="form-control"
            >
          </div>
          <div class="form-group col-md-6">
            <label for="enName">{{ $t("SmartScheduling.Room.Data.NameEN") }}</label>
            <input
              type="text"
              id="enName"
              v-model="editData[editIndex].nameEn"
              class="form-control"
            >
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="capacity">{{ $t("SmartScheduling.Room.Data.Capacity") }}</label>
            <input
              type="number"
              id="capacity"
              v-model="editData[editIndex].capacity"
              class="form-control"
            >
          </div>
          <div class="form-group col-md-6">
            <label for="email">{{ $t("SmartScheduling.Room.Data.Location") }}</label>
            <input
              type="email"
              id="email"
              v-model="editData[editIndex].location"
              class="form-control"
            >
          </div>
        </div>
      </template>
      <template #footer>
        <button
          type="button"
          class="btn btn-primary"
          @click="saveData"
        >
          {{ $t("SmartScheduling.Room.EditDone") }}
        </button>
        <button
          type="button"
          class="btn btn-outline-warning"
          @click="isOpen = false"
        >
          {{ $t("SmartScheduling.Room.EditCancel") }}
        </button>
      </template>
    </VModal>
  </div>
</template>

<script>
import VModal from '@/components/VModal.vue'

export default {
  components: {
    VModal
  },
  props: {
    items: {
      type: Array,
      default: () =>([])
    }
  },
  data: () => ({
    editData: [],
    editIndex: 0,
    sortObj: {
      // email: false,
      nameJa: false,
      nameEn: false,
      capacity: false,
      location: false,
      // sortExternalUser: false,
      // sortSeats: false,
      // sortconnectRoom: false
    },
    pageIndex: 0,
    pageStep: 10,
    isOpen: false,
  }),
  computed: {
    filterdItem() {
      return [].concat(this.editData).sort((a, b) => {
        if (!this.sortObj.nameJa) return true
        return this.sort(a.nameJa, b.nameJa, this.sortObj.nameJa === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.nameEn) return true
        return this.sort(a.nameEn, b.nameEn, this.sortObj.nameEn === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.capacity) return true
        return this.sort(Number(a.capacity), Number(b.capacity), this.sortObj.capacity === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.location) return true
        return this.sort(a.location, b.location, this.sortObj.location === 'asc')
      }).slice(this.pagenationCount.start - 1, this.pagenationCount.end)
    },
    pagenationCount() {
      if (!Array.isArray(this.items)) return { all: 0, start: 0, end: 0 }
      const all = this.items.length
      const start = (this.pageStep * this.pageIndex) + 1
      const end = (this.pageStep * (this.pageIndex + 1))
      return {
        all,
        start,
        end: (end < all) ? end : all
      }
    }
  },
  watch: {
    items: {
      immediate: true,
      handler: function (v, _) {
        this.editData = [].concat(v)
      },
      deep: true
    }
  },
  mounted() {
    this.editData = [].concat(this.items)
  },
  methods: {
    sort(a, b, isAsc) {
      if (typeof a == 'string' || a instanceof String) {
        if (isAsc) return (a < b) ? -1 : 1
        return (a < b) ? 1 :-1
      }
      if (isAsc) return b - a
      return a - b
    },
    changeSortType(target) {
      if (!this.sortObj[target]) {
        this.$set(this.sortObj, target, 'asc')
      } else if (this.sortObj[target] === 'asc') {
        this.$set(this.sortObj, target, 'desc')
      } else {
        this.$set(this.sortObj, target, false)
      }
    },
    subPagenationIndex() {
      if (this.pagenationCount.start <= 1) return false
      this.pageIndex -= 1
    },
    addPagenationIndex() {
      if (this.pagenationCount.end >= this.pagenationCount.all) return false
      this.pageIndex += 1
    },
    openModal(index) {
      this.editIndex = index
      this.isOpen = true
    },
    saveData() {
      this.$emit('save', this.editData)
      this.isOpen = false
    }
  }

/*
  data() {
    return {
      dialog: false,
      editedIndex: -1,
      editedItem: {
        index: null,
        id: null,
        email: null,
        name_ja: null,
        name_en: null,
        capacity: null,
        location: null
        // isUseOutsider: null,
        // ancillarySeatCount: null,
        // roomForConnect: null,
      }
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("SETUP.MeetingRoomsSettings.No"), value: "index" },
        { text: this.$t("SETUP.MeetingRoomsSettings.Email"), value: "email" },
        {
          text: this.$t("SETUP.MeetingRoomsSettings.RoomNameJ"),
          value: "name_ja"
        },
        {
          text: this.$t("SETUP.MeetingRoomsSettings.RoomNameE"),
          value: "name_en"
        },
        {
          text: this.$t("SETUP.MeetingRoomsSettings.Capacity"),
          value: "capacity"
        },
        {
          text: this.$t("SETUP.MeetingRoomsSettings.Location"),
          value: "location"
        },
        // { text: this.$t('SETUP.MeetingRoomsSettings.ExternalUse'), value: "isUseOutsider" },
        // { text: this.$t('SETUP.MeetingRoomsSettings.IncreasableSeats'), value: "ancillarySeatCount" },
        // { text: this.$t('SETUP.MeetingRoomsSettings.ConnectableRoom'), value: "roomForConnect" },
        {
          text: this.$t("SETUP.MeetingRoomsSettings.EditTitle"),
          value: "action",
          sortable: false
        }
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.meetingRoomSettings.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.meetingRoomSettings[this.editedIndex],
          this.editedItem
        );
      } else {
        this.meetingRoomSettings.push(this.editedItem);
      }
      this.close();
    }
  } */
}
</script>

<style lang='scss' scoped>
.room-setting-table {
  width: 100%;
}
.pagination {
  .btn {
    align-items: center;
    &.disabled {
      cursor: not-allowed;
    }
  }
}
</style>
